import React from 'react';
import { RelatedTag } from '../tags';
import { When } from 'react-if';
import { OrganizationTypeId, SonarObjectType } from '@sonar-software/sonar-ts-types';
export const SonarRecordRelationships = ({ relatedField, relatedOrgs, source }) => React.createElement(React.Fragment, null,
    React.createElement(When, { condition: source },
        React.createElement(RelatedTag, { displayName: source, sonarObjectType: SonarObjectType.PardotField })),
    React.createElement(When, { condition: relatedField },
        React.createElement(RelatedTag, { displayName: relatedField, sonarObjectType: SonarObjectType.SalesforceField })), relatedOrgs === null || relatedOrgs === void 0 ? void 0 :
    relatedOrgs.map((orgTypeId) => React.createElement(RelatedTag, { displayName: OrganizationTypeId[orgTypeId], key: orgTypeId })));
